import { Component } from '@angular/core';
import { General_Config } from './General_Config';
import { CommonFunctionsService } from './common-functions.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  constructor(public commonFunctions: CommonFunctionsService) {
    let token = window.localStorage.getItem(General_Config.session_key + 'token');
    if (!token) {
      this.commonFunctions.goToPage('/login');
    }
  }
}
